// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__bZW1K","top":"styles_top__xzZ9D","bottom":"styles_bottom__1AEaY","left":"styles_left__KE8aT","right":"styles_right__s9bYJ"};